const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfReligion extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfReligion,
            "Each player with an unused worker may immediately build and age A temple for free.",
            {}
        )
    }
}

module.exports = DevelopmentOfReligion;